import { AppSharedModule } from '../app-shared.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '../components/components.module';
import { ManutencaoRoutingModule } from './manutencao.routing';
import { ManutencaoSincronizarProcessosComponent } from './manutencao-sincronizar-processos/manutencao-sincronizar-processos.component';
import { ManutencaoProcessarDocumentoComponent } from './manutencao-processar-documentos/manutencao-processar-documentos.component';
import { ManutencaoReprocessarDocumentoComponent } from './manutencao-reprocessar-documentos/manutencao-reprocessar-documentos.component';
import { ManutencaoSincronizarProcessosAssociacoesComponent } from './manutencao-sincronizar-processos-associacoes/manutencao-sincronizar-processos-associacoes.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    ManutencaoReprocessarDocumentoComponent,
    ManutencaoSincronizarProcessosComponent,
    ManutencaoProcessarDocumentoComponent,
    ManutencaoSincronizarProcessosAssociacoesComponent
  ],
  exports: [
    ManutencaoRoutingModule
  ],
  providers: []
})
export class ManutencaoModule { }
